import React from 'react'
import { connect } from 'react-redux'
import { actionCreators } from '@/store/ReportSubmissions'
import context from '@/context'
import { Main, MainBody, MainTop, MainTopTitle, WhiteBox } from '@/components/Layout'
import { Row, Col } from 'reactstrap'
import Resx from '@/components/Resx'
import { localized } from '@/decorators/localized'
import ReportAttachments from '@/components/reporting/reportAttachments'
import ReportSubmissionComments from '@/components/reporting/reportSubmissionComments'
import LoadingIndicator from '@/components/LoadingIndicator'
import Name from '@/components/Name'
import { ReportSubmissionState } from '@/enums/ReportSubmissionState'
import getEnumTranslation from '@/enums/enums'
import { formatDate } from '@/utils/dateUtilities'
import ErrorButton from '@/components/ErrorButton'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ReportSubmissionTable } from './reportSubmissionTable'
import { reportSubmissionsStatus } from '@/components/reporting/submissions/reportSubmissionsStatus'
import { ReportSubmissionTitle } from '@/components/reporting/submissions/reportSubmissionTitle'
import { Forecasting } from '@/components/reporting/forecasting'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import { ReportSubmissionGroupNotes } from '@/components/reporting/reportSubmissionGroupNotes'
import { CheckingRulesList } from '@/components/reporting/submissions/checkingRulesList'

@localized()
class ReportSubmissionDetail extends React.Component {
  constructor (props) {
    super(props)
    this.getParentId = this.getParentId.bind(this)
    this.goBack = this.goBack.bind(this)
  }

  getSubmissionId () {
    return this.props.match.params.id
  }
  getParentId () {
    return this.props.match.params.parentId
  }
  getBackUrl (forecasting) {
    const url = forecasting ? 'forecast-report-submission-groups' : 'report-submission-groups'
    return `/${url}/${this.getParentId()}/report-submissions`
  }
  goBack (forecasting) {
    const url = this.getBackUrl(forecasting)
    this.props.history.push(url)
  }
  componentDidMount () {
    this.reload()
  }
  componentDidUpdate (prevProps, prevState) {
    if (this.getSubmissionId() !== prevProps.match.params.id) {
      this.reload()
    }
  }
  reload = () => {
    this.props.getWithGroup(this.getSubmissionId(), this.getParentId())
  }

  renderCheckingRules () {
    const { checkingRuleSubmissions } = this.props.reportSubmissions.reportSubmission

    if (!checkingRuleSubmissions || !checkingRuleSubmissions.length) return

    return <CheckingRulesList checkingRules={checkingRuleSubmissions} onlyShowIssues />
  }

  renderGeneralBox (reportSubmissionWithGroup) {
    const { localize } = this.props
    if (reportSubmissionWithGroup === null) {
      return (
        <WhiteBox backUrl='/' header='Reporting.General'>
          <ErrorButton className='white-box-center' onClick={this.reload} />
        </WhiteBox>
      )
    }
    const reportSubmission = reportSubmissionWithGroup.reportSubmission || {}
    const reportSubmissionGroup = reportSubmissionWithGroup.reportSubmissionGroup || {}

    const status = getEnumTranslation({ localize, enumName: ReportSubmissionState.enumName, value: reportSubmission.state })
    return (
      <WhiteBox header='Reporting.General'>
        <Forecasting forecasting={reportSubmissionGroup.forecasting} />
        <Row>
          <Col sm='6'>
            <InfoRow>
              <InfoLabel><Resx name='Common.Name' /></InfoLabel>
              <InfoContent><Name data={reportSubmission} /></InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Reporting.ReportTemplateName' /></InfoLabel>
              <InfoContent><Name data={reportSubmission.reportTemplateVersion} /></InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Reporting.ReportGroupSubmissionName' /></InfoLabel>
              <InfoContent><a className='link-regular' onClick={() => this.goBack(reportSubmissionGroup.forecasting)}><Name data={reportSubmissionGroup} /></a></InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Reporting.InstitutionName' /></InfoLabel>
              <InfoContent><Name data={reportSubmissionGroup.institution} /></InfoContent>
            </InfoRow>
          </Col>
          <Col sm='6'>
            <InfoRow>
              <InfoLabel><Resx name='Common.SubmittedAt' /></InfoLabel>
              <InfoContent>{formatDate(reportSubmissionGroup.submittedAt) || '---'}</InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Reporting.LastUpdatedAt' /></InfoLabel>
              <InfoContent>{formatDate(reportSubmission.lastStateModificationTime) || '---'}</InfoContent>
            </InfoRow>
            <InfoRow>
              <InfoLabel><Resx name='Common.State' /></InfoLabel>
              <InfoContent className='border-less'><span className={'status status--' + reportSubmissionsStatus(reportSubmission.state)}>{status}</span></InfoContent>
            </InfoRow>
          </Col>
        </Row>
      </WhiteBox>
    )
  }
  renderBody () {
    const { reportSubmissions, addAttachments } = this.props

    if (reportSubmissions.fetching === true) { return (<LoadingIndicator />) }
    const submissionId = this.getSubmissionId()
    return (
      <React.Fragment>
        <WhiteBox>
          <Row>
            <Col sm='12'>
              <ErrorBoundary>
                <Resx render={(x) => <ReportSubmissionTable
                  isRtl={x.rtl}
                  isLoading={reportSubmissions.fetching}
                  reportSubmission={reportSubmissions.reportSubmission}
                  cellMetadata={reportSubmissions.cellMetadata}
                  sourceHeaders={reportSubmissions.sourceHeaders}
                  sourceRowHeaders={reportSubmissions.sourceRowHeaders}
                  sourceData={reportSubmissions.sourceData}
                  key={reportSubmissions.key}
                  readOnly />}
                />
              </ErrorBoundary>
            </Col>
          </Row>
        </WhiteBox>
        <Row>
          <Col sm='12'>
            <ErrorBoundary>
              <ReportAttachments
                key={reportSubmissions.attachmentsKey}
                disabled
                dataSource={() => context.api.reportSubmissionService.getAttachments(submissionId)}
                downloadAction={context.api.reportSubmissionService.download}
                parentId={submissionId}
                addAttachments={addAttachments}
                removeAttachment={id => this.props.removeAttachments({ entityId: submissionId, fileIds: [id] })}
                adding={reportSubmissions.adding} />
            </ErrorBoundary>
          </Col>
        </Row>
        <Row>
          <Col sm='12'>
            <ErrorBoundary>
              <ReportSubmissionComments showExternalVisibilityCheckbox parentId={submissionId} disabled={false} />
            </ErrorBoundary>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
  render () {
    const { reportSubmissions } = this.props
    if (reportSubmissions.fetching === true) { return (<LoadingIndicator />) }
    const reportSubmissionGroup = reportSubmissions.reportSubmissionWithGroup || {}
    const reportSubmissionGroupDetail = reportSubmissionGroup.reportSubmissionGroup || {}
    const reportSubmissionGroupForecasting = reportSubmissionGroupDetail.forecasting

    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl={this.getBackUrl(reportSubmissionGroupForecasting)}>
            <Resx name='Reporting.ReportSubmissionDetailTitle' /> <ReportSubmissionTitle reportSubmission={this.props.reportSubmissions.reportSubmission} />
          </MainTopTitle>
        </MainTop>
        <MainBody transparent>
          {this.renderGeneralBox(reportSubmissions.reportSubmissionWithGroup)}
          {this.renderBody()}
          {reportSubmissions.reportSubmission && this.renderCheckingRules()}
          <ReportSubmissionGroupNotes reportSubmission={reportSubmissionGroup.reportSubmission || {}} />
        </MainBody>
      </Main>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reportSubmissions: state.reportSubmissions,
    ...ownProps
  }
}

const mapDispatchToProps = {
  getWithGroup: actionCreators.getWithGroup
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportSubmissionDetail)



// WEBPACK FOOTER //
// ./src/internal-app/pages/reportSubmissionGroups/submissions/detail/reportSubmissionDetail.js